/**
 *
 * ResetPassword
 *
 */
import React, { memo } from "react";
import { CreateNewPassword } from "./components/ForgotPasswrd";
import { LayoutStyles } from "../signin/components/LayoutStyles";

interface Props {}

export const ResetPassword = memo((props: Props) => {
  return (
    <div className="relative h-screen min-h-[40rem] p-14 overflow-hidden">
      <LayoutStyles currentStep={2} />
      <div className="flex w-full h-full bg-[#5B73F14D]">
        {/* Left Part */}
        <div className="flex items-center justify-center flex-1 bg-[#F2F4F8] px-12 py-14 [@media(min-width:1800px)]:px-[6.25rem] [@media(min-width:1800px)]:py-[7.5rem] rounded-tl-lg rounded-bl-[6rem]">
          <div className="relative z-[1]">
            <img
              src="/images/loop.svg"
              alt="Loop Celestial Logo"
              className="w-[6.36556rem] h-[8.34525rem]"
            />
          </div>
        </div>
        {/* Right Part */}
        <div className="relative z-[4] flex flex-col flex-1 gap-20 [@media(min-width:1800px)]:gap-[6.38rem] px-12 py-14 [@media(min-width:1800px)]:px-[6.25rem] [@media(min-width:1800px)]:py-[7.5rem] bg-white rounded-r-lg">
          <CreateNewPassword />
        </div>
      </div>
    </div>
  );
});
